import { useMemo } from 'react';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { WithAccountId } from '@mews-commander/types';
import { TableHeader, useTableState } from '@optimus-web/core';
import { Settlement } from '@mews-commander/data-access';
import { TableDivider } from '../TableDivider';
import { PaymentTable } from '../PaymentTable';
import { useGetSettlements } from './queries';
import { getSettlementsTableColumns } from './settlementsTableMapping';

interface SettlementsTableProps extends WithAccountId {
    hideDivider?: boolean;
}

export const SettlementsTable = ({ accountId, hideDivider = false }: SettlementsTableProps) => {
    const { data = [], isFetching, isError, refetch } = useGetSettlements({ accountId });
    const [tableState, setTableState] = useTableState<Settlement>({
        pagination: {
            show: false,
        },
    });

    const columns = useMemo(() => getSettlementsTableColumns({ accountId }), [accountId]);

    return (
        <>
            <TableHeader title={<LocalizedText textKey={TextKey.ScheduledPaymentsPreauths} />} />
            <PaymentTable
                columns={columns}
                data={data}
                uniqueRowId="id"
                state={tableState}
                onStateChange={setTableState}
                amountOfRows={data.length}
                loading={isFetching}
                isError={isError}
                onTryAgain={async () => refetch()}
            />
            {!hideDivider && <TableDivider />}
        </>
    );
};
